import { ApiError } from '../api/client.ts';

/** Message d'erreur à afficher : la raison donnée par le serveur d'abord, jamais un texte générique s'il y en a une. */
export function errorMessage(err: unknown): string {
  if (err instanceof ApiError) return err.problem.detail;
  if (err instanceof Error && err.message) return err.message;
  return 'Une erreur inattendue est survenue.';
}

export function formatDateTime(iso: string | null | undefined, locale: string, timeZone?: string): string {
  if (!iso) return '—';
  return new Intl.DateTimeFormat(locale, { dateStyle: 'medium', timeStyle: 'short', timeZone }).format(new Date(iso));
}

/** Date calendaire (AAAA-MM-JJ) sans décalage de fuseau. */
export function formatDate(date: string | null | undefined, locale: string): string {
  if (!date) return '—';
  const [y, m, d] = date.slice(0, 10).split('-').map(Number);
  if (!y || !m || !d) return date;
  return new Intl.DateTimeFormat(locale, { dateStyle: 'medium', timeZone: 'UTC' }).format(new Date(Date.UTC(y, m - 1, d)));
}

/** Date du jour (AAAA-MM-JJ) dans le fuseau demandé, ou celui du navigateur par défaut. */
export function todayIso(timeZone?: string, now = new Date()): string {
  if (timeZone) {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone, year: 'numeric', month: '2-digit', day: '2-digit',
    }).formatToParts(now);
    const read = (type: Intl.DateTimeFormatPartTypes) => parts.find((part) => part.type === type)?.value;
    return `${read('year')}-${read('month')}-${read('day')}`;
  }
  const d = now;
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]!.toUpperCase())
    .join('');
}
